import { Translation } from '../interfaces/Translation';

const translation: Translation = {
	PageSize: 'Papierformat',
	PageOrientation: 'Papierausrichtung',
	Format: 'Dateiformat',
	DPI: 'Druckauflösung',
	Generate: 'Erstellen',
	LanguageName: 'Deutsch',
	LanguageCode: 'de'
};

export default translation;
